import { SVGIconComponent } from './types';

export const ProjectTypeTheme: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{ color, ...style }}
    className={className}
  >
    <path
      fill="currentColor"
      d="M13.847 11.323c.853.35 1.27 1.362.929 2.257-.36.914-1.309 2.043-3.13 2.412-.265.059-.455-.233-.322-.466.74-1.304-.057-2.296.322-3.25a1.685 1.685 0 0 1 2.2-.953M7.89 3.268a9.9 9.9 0 0 1 3.357.584c.74.292.815 1.303.151 1.731-1.213.817-1.896 1.77-1.707 2.666.152.798 1.006 1.362 2.22 1.615l-.038.117-.076.234a3.02 3.02 0 0 0-1.365 1.557c-.304.74-.228 1.4-.152 1.946.075.545.095.798-.095 1.128-.114.195-.19.428-.21.662a9 9 0 0 1-2.085.233C3.528 15.741 0 12.958 0 9.514s3.528-6.246 7.89-6.246m.284 8.873a.964.964 0 0 0-.948.973c0 .525.417.973.948.973a.98.98 0 0 0 .968-.973.98.98 0 0 0-.968-.973m-3.68-.662a.964.964 0 0 0-.948.973c0 .525.418.973.949.973a.94.94 0 0 0 .948-.973c0-.525-.417-.973-.948-.973m10.64-7.433c.267-.837 1.158-1.265 1.954-.934.778.312 1.138 1.265.76 2.062l-2.619 5.468a2.8 2.8 0 0 0-.89-.564c-.323-.156-.684-.213-1.044-.233ZM2.259 8.638c-.512 0-.949.467-.949.993 0 .525.417.973.949.973a.967.967 0 0 0 .967-.973c0-.545-.436-.993-.967-.993M4.344 5.7a.98.98 0 0 0-.968.973c0 .525.456.973.968.973s.948-.448.948-.973-.417-.973-.948-.973M7.89 4.494c-.512 0-.948.448-.967.993 0 .525.456.973.967.973a.964.964 0 0 0 .949-.973c0-.545-.417-.993-.949-.993"
    />
  </svg>
);
